module.exports = __webpack_public_path__ + "img/qr_mini.ef4abdfa.png";